import {BackupRestoreProgress} from "./backup-restore-progress";
import {Utils} from "../../../shared/utils/utils";

export class BackupRestoreProgressMapper {

  public static map(data: any): BackupRestoreProgress {
    const backupRestoreProgress: BackupRestoreProgress = new BackupRestoreProgress();
    backupRestoreProgress.id = data.id;
    backupRestoreProgress.websiteId = data.domain_id;
    backupRestoreProgress.backupId = data.backup_id;
    backupRestoreProgress.status = data.status; // "active"|"success"|"fail"
    backupRestoreProgress.active = data.status === 'active';
    backupRestoreProgress.creationDate = data.created_at ? Utils.getDate(data.created_at) : null;
    backupRestoreProgress.updatedDate = data.updated_at ? Utils.getDate(data.updated_at) : null;

    backupRestoreProgress.progressPercent = Math.round(data.progress);
    backupRestoreProgress.complete = ['success', 'fail'].indexOf(data.status) !== -1;
    backupRestoreProgress.message = data.message;

    return backupRestoreProgress;
  }

}
